import { CONTAINER_BACKGROUND_COLOR, CONTAINER_BORDER_RADIUS } from '../constants';
import { Area, Drawer } from '../types';

export class ContainerDrawer implements Drawer {
    private area: Area;

    constructor(area: Area) {
        this.area = area;
    }

    draw(ctx: CanvasRenderingContext2D) {
        ctx.beginPath();
        ctx.fillStyle = CONTAINER_BACKGROUND_COLOR;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        ctx.roundRect(this.area.x, this.area.y, this.area.width, this.area.height, CONTAINER_BORDER_RADIUS);
        ctx.fill();
    }
}
